import styled from 'styled-components';

export const ChatLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;

  {Transcript} {
    min-height: 1px;
    flex-basis: 100%;
  }
`;
